<template>
  <div id="app">
    <router-view />
  </div>
</template>

<script>
export default {
  name: 'App'
}
</script>

<style>
* {
  margin: 0;
  padding: 0;
  box-sizing: border-box;
}

html,
body {
  width: 100%;
  height: 100%;
  /* overflow: hidden; */
}

#app {
  width: 100%;
  height: 100%;
  /* overflow: hidden; */
}
</style>
